// Device Group Item
//
// A Mixin to build v5 device groups
//
// Should be extended to show particular Device Group Types
// unless the basic default handling happens below.
//
// ex: public/js/views/list_item/factory_device_group.js
//
// Would like to make this file more like a Vue project.
//

// Item view for a pre_factoryfixture_workspace, intended to be used by the
//    show_pre_factoryfixture_devicegroups controller

import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DeploymentItemView from '@/views/deployment_item';
import IDView from '@/views/id_view';
import FactoryDeviceGroupItem from '@/views/list_item/factory_device_group';
import ProductionDeviceGroupItem from '@/views/list_item/production_device_group';
import DUTDeviceGroupItem from '@/views/list_item/dut_device_group';
import ProductItemView from '@/views/list_item/product';
import CollaboratorItem from '@/views/collaborator_item';
import template from '@/views/list_item/device_group_item_template';
const globalCh = Radio.channel('global');
const apiCh = Radio.channel('api');

var DeviceGroupItemMixin = {
    template: Handlebars.compile(template),
    attributes: function () {
        return {
            "data-id": this.model.id,
        };
    },

    render_device_group_info: function () {
        let can_view_code = false;
        var current_deployment = this.model.rel.get('current_deployment');
        if (this.model.type === 'pre_factoryfixture_devicegroup' || this.model.type.indexOf('pre') > -1 || this.model.type === 'development_devicegroup') can_view_code = true;

        let devices_template = `<i class="fa ei-icon-device" data-id="devices"></i>
                                <strong>Devices</strong> {{devices}}`;

        if (!this.model.counts.get('id')) this.model.counts.fetch();
        
        let device_count_view = new Marionette.View({
            tagName: 'span',
            className: 'devices-link btn btn-link',
            model: this.model.counts,
            template: Handlebars.compile(devices_template),
            modelEvents: { 'change': 'render' }
        });
 
        // Show a dedicated view for the counts
        this.showChildView('devicecount_info', device_count_view );

        let id_view = new IDView({ model: this.model });

        let deployment_item_view = new DeploymentItemView({
                tagName: 'li',
                model: current_deployment,
                can_view_code: can_view_code,
        });
        let last_deployed_view;

        let deployment_template = `<div class="date"><strong><i class="fa fa-calendar" data-id="devicegroups"></i> Deployed On </strong>{{#date_UTC}}{{created_at}}{{/date_UTC}}</div>`;
        let no_deployment_template = `<div class="date"><strong><i class="fa fa-calendar" data-id="devicegroups"></i> Deployed On </strong> --</div>`;

        if (current_deployment) {
            last_deployed_view = new Marionette.View({
                template: Handlebars.compile(deployment_template),
                tagName: 'span',
                model: current_deployment
            });
        } else {
            last_deployed_view = new Marionette.View({
                template: Handlebars.compile(no_deployment_template),
                tagName: 'span',
                model: current_deployment
            });
        }

        if (current_deployment && !current_deployment.get('created_at')){
            current_deployment.fetch({
                    data: { nocode: true }
                })
                .then(function(){
                    this.showChildView('devicegroup_info', id_view);
                    this.showChildView('deployment_info', deployment_item_view);
                    this.showChildView('last_deployed_info', last_deployed_view);
                }
                .bind(this));
        } else {
            this.showChildView('devicegroup_info', id_view);
            this.showChildView('deployment_info', deployment_item_view);
            this.showChildView('last_deployed_info', last_deployed_view);
        }
    },
    render_relationships: function(keys) {
        let self = this;
        let active = globalCh.request('active_account');
        let primary = globalCh.request('primary_account');
        let relationships = new Backbone.Collection();
        let rels = keys;
        if ( !keys ) {
            rels = Object.keys(this.model.rel.attributes);
        }
        rels.forEach(function(k) { relationships.push(self.model.rel.attributes[k]); });
        let rel_list_view = new Marionette.CollectionView({
            collection: relationships,
            childView: function(model){
                let can_view_code = false;
                switch (model.type) {
                    case 'account': 
                        return CollaboratorItem.extend({targetAccount: active });
                    case 'product':
                        return ProductItemView;
                    case 'factoryfixture_devicegroup':
                        return FactoryDeviceGroupItem;
                    case 'pre_factoryfixture_devicegroup':
                        return FactoryDeviceGroupItem;
                    case 'production_devicegroup':
                        can_view_code = active.permits(primary, 'view_production_code');
                        return ProductionDeviceGroupItem.extend({
                            model: model,
                            can_view_code: can_view_code,
                            can_view_devices: true,
                            expandable: false,
                            show_actions: false,
                            relationship_type: 'Production Target'
                        });
                    case 'pre_production_devicegroup':
                        can_view_code = active.permits(primary, 'view_pre_production_code');
                        return ProductionDeviceGroupItem.extend({
                            model: model,
                            can_view_code: can_view_code,
                            can_view_devices: true,
                            expandable: false,
                            show_actions: false,
                            relationship_type: 'Test Production Target'
                        });
                    case 'pre_dut_devicegroup':
                        can_view_code = active.permits(primary, 'view_pre_dut_code');
                        return DUTDeviceGroupItem.extend({
                            model: model,
                            can_view_code: can_view_code,
                            can_view_devices: true,
                            expandable: false,
                            show_actions: false,
                            relationship_type: 'Test DUT Target'
                        });
                    case 'dut_devicegroup':
                        can_view_code = active.permits(primary, 'view_pre_dut_code');
                        return DUTDeviceGroupItem.extend({
                            model: model,
                            can_view_code: can_view_code,
                            can_view_devices: true,
                            expandable: false,
                            show_actions: false,
                            relationship_type: 'DUT Target'
                        });
                    default: {
                        let quick_template = '<div class="default">name: <b>{{name}}</b> type: <b>' + model.type + '</b> id: <b>' + model.id + '</b></div>';
                        return Marionette.View.extend({
                            template: Handlebars.compile(quick_template),
                        });
                    }
                }
            }
        });
        this.showChildView('relationships_region', rel_list_view);
    },
    ui: {
        name: '.name',
        draft_code: '.action.draft-code',
        code_history: '.action.code-history',
        delete: '.action.delete',
        settings: '.action.settings',
        blessed_devices: '.action.blessed-devices',
        devices: '.action.devices,.devices-link',
        go_live: '.action.go-live',
        go_live_region: '.go-live-region',
        tooltips: '[data-toggle="tooltip"]',
        clone: '.clone',
        expando: '.expando',
        retracto: '.retracto',
    },
    regions: {
        devicegroup_info: '.devicegroup-info',
        devicecount_info: '.devicecount-info',
        deployment_info: '.deployment-info',
        last_deployed_info: '.last-deployed-info',
        relationships_region: '.relationships-region',
        go_live_region: '.go-live-region'
    },
    events: {
        'click @ui.name': 'show_dashboard',
        'click @ui.draft_code': 'show_draft_code',
        'click @ui.code_history': 'show_code_history',
        'click @ui.deploy': 'show_deployment_dialog',
        'click @ui.delete': 'show_delete_dialog',
        'click @ui.settings': 'show_settings_dialog',
        'click @ui.blessed_devices': 'show_blessed_devices',
        'click @ui.devices': 'show_devices',
        'click @ui.clone': 'clone',
        'click @ui.expando': 'expand',
        'click @ui.retracto': 'retract',
    },
    modelEvents: {
        'change': 'render'
    },
    onRender: function() {
        this.ui.retracto.hide();
        this.ui.tooltips.tooltip();
        this.render_device_group_info();
        this.listenTo(this.model, 'change', this.render);
    },
    expand: function(e) {
        e.stopPropagation();
        this.ui.retracto.show();
        this.ui.expando.hide();
        this.render_relationships();
    },
    retract: function(e) {
        e.stopPropagation();
        this.ui.retracto.hide();
        this.ui.expando.show();
        this.getRegion('relationships_region').empty();
    },
    // ACTIONS
    show_dashboard: function(e) {
        e.stopPropagation();
        globalCh.request('show_devicegroup_dashboard', this.model, this.model.rel.get('product'));
    },
    show_draft_code: function (e) {
        e.stopPropagation();
        var draft = this.model.draft;
        var devicegroup = this.model;
        
        globalCh.request('showCodeEditor', draft, devicegroup);
    },
    show_code_history: function (e) {
        e.stopPropagation();
        globalCh.request('show_devicegroup_code_history',
                                    this.model,
                                    this.model.rel.get('product'));
    },
    show_delete_dialog: function (e) {
        e.stopPropagation();
        globalCh.request('show_delete_devicegroup_dialog', this.model);
    },
    show_settings_dialog: function(e) {
        e.stopPropagation();
        if (this.model.type === 'factory_devicegroup' || this.model.type === 'factoryfixture_devicegroup') {
            globalCh.request('show_factory_device_group_settings_dialog', this.model);
        } else if (this.model.type === 'production_devicegroup' || this.model.type === 'pre_production_devicegroup') {
            globalCh.request('showProductionDeviceGroupSettingsDialog', { model: this.model });
        } else {
            globalCh.request('show_development_devicegroup_settings_dialog', this.model);
        }
    },
    show_blessed_devices: function(e) {
        e.stopPropagation();
        globalCh.request('show_devices', this.model);
    },
    clone: function() {
        globalCh.request('show_clone_devicegroup', this.model);
    },
    show_devices: function (e) {
        let devicegroups = apiCh.request('development_devicegroup');
        let types = devicegroups.TYPES_MAP;
        let devicegroup = this.model;
        let type = devicegroup.type;
        switch (type) {
            case types.development:
                globalCh.request('show_development_devices', devicegroup);
                break;
            case types.pre_factoryfixture:
                globalCh.request('show_pre_factoryfixture_devices', devicegroup);
                break;
            case types.factoryfixture:
                globalCh.request('show_factory_devices', devicegroup);
                break;
            case types.pre_production:
                globalCh.request('show_pre_production_devices', devicegroup);
                break;
            case types.production:
                globalCh.request('show_production_devices', devicegroup);
                break;
            case types.dut:
                globalCh.request('show_dut_devices', devicegroup);
                break;
            case types.pre_dut:
                globalCh.request('show_pre_dut_devices', devicegroup);
                break;
            default:
                globalCh.request('show_devices', devicegroup);
                break;
        }
    },

    show_deployment_dialog: function () {
            globalCh.request('show_create_deployment_dialog', this.model);
    },
};

export default DeviceGroupItemMixin;


